import PropTypes from 'prop-types';

const DropDownItem = ({ onClose, children }) => {
  return (
    <li>
      <div
        role="button"
        tabIndex="0"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
            onClose();
          }
        }}
      >
        {children}
      </div>
    </li>
  );
};

DropDownItem.propTypes = {
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DropDownItem;
